export default {"src":"/_next/static/media/Junior-badge.48d3ec7d.svg","height":46,"width":46};